var indentStyle = {"indentZero":"G0cSB","indentOne":"-iROQ","indentTwo":"cQNGg","indentThree":"s26su","indentFour":"K48rD","indentFive":"ytwHG","indentSix":"SdYyI"};

export { indentStyle as i };
//# sourceMappingURL=indentation-798a770a.js.map
